import { Grid2 } from '@aibees/shared/components';
import { useCreditUsageItems } from '@aibees/shared/hooks';
import { classnames } from '@aibees/shared/utils';
import { Box, Skeleton } from '@mui/material';
import { memo } from 'react';
import { CurrentPlanCredit } from './components/current-plan-credit';
import { RuleItem } from './components/rule-item';
import * as Styled from './styles';
import * as SX from './sx';
import type { PlanRulesProps as Props } from './types';

const SKELETON_COUNT = 14;

export const PlanRules = memo(
  ({ className, currentPlan, subscriptionType }: Props) => {
    const { items, isLoading } = useCreditUsageItems();

    return (
      <Styled.Wrapper className={classnames('PlanRules', className)}>
        <Box sx={SX.box}>
          <Grid2 container columns={48}>
            {isLoading
              ? Array.from({ length: SKELETON_COUNT }).map((_, index) => (
                  <Grid2 sx={SX.item} key={index} xs={48} md={24} lg={12}>
                    <Skeleton variant="rounded" height={40} />
                  </Grid2>
                ))
              : items.map((i) => (
                  <Grid2 sx={SX.item} key={i.title} xs={48} md={24} lg={12}>
                    <RuleItem rule={i} />
                  </Grid2>
                ))}
          </Grid2>
        </Box>
        <Box sx={SX.box}>
          <CurrentPlanCredit
            currentPlan={currentPlan}
            subscriptionType={subscriptionType}
          />
        </Box>
      </Styled.Wrapper>
    );
  }
);

PlanRules.displayName = 'PlanRules';
